export function getLocale() {
  let locale = window.localStorage.getItem('SEI_POCKET_LOCALE') || '';
  const allowedLangs = ['pt', 'en', 'es'];

  if (!allowedLangs.includes(locale)) {
    locale = 'pt';
  }
  return locale;
}



// WEBPACK FOOTER //
// ./src/i18n/helper.ts